export default "__VITE_ASSET__BeFVhEFm__"